export const COUNTRY_OR_REGION_LIST = () => {
  const NEUTRAL = process.env.appmode === 'NEUTRAL';
  const MODE = process.env.mode;
  let countryArr = [];

  countryArr = (NEUTRAL && MODE !== 'uat') ? [ //中性只支持美国和加拿大
    { index: 23, label: 'UnitedStates', countryCode: 'US' },
    { index: 24, label: 'Canada', countryCode: 'CA' }
  ] : [
    { index: 0, label: 'Austria', countryCode: 'AT' },
    { index: 1, label: 'Belgium', countryCode: 'BE' },
    { index: 2, label: 'Croatia', countryCode: 'HR' },
    { index: 3, label: 'Czech', countryCode: 'CZ' },
    { index: 4, label: 'Denmark', countryCode: 'DK' },
    { index: 5, label: 'Finland', countryCode: 'FI' },
    { index: 6, label: 'France', countryCode: 'FR' },
    { index: 7, label: 'Germany', countryCode: 'DE' },
    { index: 8, label: 'Greece', countryCode: 'GR' },
    { index: 9, label: 'Hungary', countryCode: 'HU' },
    { index: 10, label: 'Italy', countryCode: 'IT' },
    { index: 11, label: 'Netherlands', countryCode: 'NL' },
    { index: 12, label: 'Norway', countryCode: 'NO' },
    { index: 13, label: 'Poland', countryCode: 'PL' },
    { index: 14, label: 'Portugal', countryCode: 'PT' },
    { index: 15, label: 'Romania', countryCode: 'RO' },
    { index: 16, label: 'Serbia', countryCode: 'RS' },
    { index: 17, label: 'Slovak', countryCode: 'SK' },
    { index: 18, label: 'Slovenia', countryCode: 'SI' },
    { index: 19, label: 'Spain', countryCode: 'ES' },
    { index: 20, label: 'Sweden', countryCode: 'SE' },
    { index: 21, label: 'Switzerland', countryCode: 'CH' },
    { index: 22, label: 'UnitedKingdom', countryCode: 'GB' },
    { index: 23, label: 'UnitedStates', countryCode: 'US' },
    { index: 24, label: 'Canada', countryCode: 'CA' },
    { index: 25, label: 'Afghanistan', countryCode: 'AF' },
    { index: 27, label: 'Albania', countryCode: 'AL' },
    { index: 28, label: 'Algeria', countryCode: 'DZ' },
    { index: 29, label: 'Andorra', countryCode: 'AD' },
    { index: 30, label: 'Angola', countryCode: 'AO' },
    { index: 31, label: 'Anguilla', countryCode: 'AI' },
    { index: 32, label: 'Antarctica', countryCode: 'AQ' },
    { index: 33, label: 'AntiguaAndBarbuda', countryCode: 'AG' },
    { index: 34, label: 'Argentina', countryCode: 'AR' },
    { index: 35, label: 'Armenia', countryCode: 'AM' },
    { index: 36, label: 'Aruba', countryCode: 'AW' },
    { index: 39, label: 'Australia', countryCode: 'AU' },
    { index: 40, label: 'Azerbaijan', countryCode: 'AZ' },
    { index: 41, label: 'Bahamas', countryCode: 'BS' },
    { index: 42, label: 'Bahrain', countryCode: 'BH' },
    { index: 43, label: 'Bangladesh', countryCode: 'BD' },
    { index: 44, label: 'Barbados', countryCode: 'BB' },
    { index: 45, label: 'Belarus', countryCode: 'BY' },
    { index: 46, label: 'Belize', countryCode: 'BZ' },
    { index: 47, label: 'Benin', countryCode: 'BJ' },
    { index: 48, label: 'Bermuda', countryCode: 'BM' },
    { index: 49, label: 'Bhutan', countryCode: 'BT' },
    { index: 50, label: 'Bolivia', countryCode: 'BO' },
    { index: 51, label: 'Bonaire', countryCode: 'BQ' },
    { index: 52, label: 'BosniaAndHerzegovina', countryCode: 'BA' },
    { index: 53, label: 'Botswana', countryCode: 'BW' },
    { index: 54, label: 'Brazil', countryCode: 'BR' },
    { index: 55, label: 'Brunei', countryCode: 'BN' },
    { index: 56, label: 'Bulgaria', countryCode: 'BG' },
    { index: 57, label: 'BurkinaFaso', countryCode: 'BF' },
    { index: 58, label: 'Burma', countryCode: 'MM' },
    { index: 59, label: 'Burundi', countryCode: 'BI' },
    { index: 60, label: 'Cambodia', countryCode: 'KH' },
    { index: 61, label: 'Cameroon', countryCode: 'CM' },
    { index: 62, label: 'CapeVerde', countryCode: 'CV' },
    { index: 63, label: 'CaymanIslands', countryCode: 'KY' },
    { index: 64, label: 'CentralAfricanRepublic', countryCode: 'CF' },
    { index: 65, label: 'Chad', countryCode: 'TD' },
    { index: 66, label: 'Chile', countryCode: 'CL' },
    { index: 67, label: 'Colombia', countryCode: 'CO' },
    { index: 68, label: 'Comoros', countryCode: 'KM' },
    { index: 69, label: 'Congo_Brazzaville', countryCode: 'CG' },
    { index: 70, label: 'Congo_Kinshasa', countryCode: 'CD' },
    { index: 71, label: 'CookIslands', countryCode: 'CK' },
    { index: 72, label: 'CostaRica', countryCode: 'CR' },
    { index: 73, label: 'CoteD_Ivoire', countryCode: 'CI' },
    { index: 74, label: 'Curacao', countryCode: 'CW' },
    { index: 75, label: 'Cyprus', countryCode: 'CY' },
    { index: 76, label: 'Djibouti', countryCode: 'DJ' },
    { index: 77, label: 'Dominica', countryCode: 'DM' },
    { index: 78, label: 'DominicanRepublic', countryCode: 'DO' },
    { index: 79, label: 'Ecuador', countryCode: 'EC' },
    { index: 80, label: 'Egypt', countryCode: 'EG' },
    { index: 81, label: 'ElSalvador', countryCode: 'SV' },
    { index: 82, label: 'EquatorialGuinea', countryCode: 'GQ' },
    { index: 83, label: 'Eritrea', countryCode: 'ER' },
    { index: 84, label: 'Estonia', countryCode: 'EE' },
    { index: 85, label: 'Ethiopia', countryCode: 'ET' },
    { index: 87, label: 'FalklandIslands_Malvinas', countryCode: 'FK' },
    { index: 88, label: 'Fiji', countryCode: 'FJ' },
    { index: 89, label: 'FrenchGuiana', countryCode: 'GF' },
    { index: 90, label: 'FrenchPolynesia', countryCode: 'PF' },
    { index: 91, label: 'Gabon', countryCode: 'GA' },
    { index: 92, label: 'Gambia', countryCode: 'GM' },
    { index: 93, label: 'Georgia', countryCode: 'GE' },
    { index: 94, label: 'Ghana', countryCode: 'GH' },
    { index: 95, label: 'Greenland', countryCode: 'GL' },
    { index: 96, label: 'Grenada', countryCode: 'GD' },
    { index: 97, label: 'Guadeloupe', countryCode: 'GP' },
    { index: 98, label: 'Guatemala', countryCode: 'GT' },
    { index: 99, label: 'Guinea', countryCode: 'GN' },
    { index: 100, label: 'Guinea_Bissau', countryCode: 'GW' },
    { index: 101, label: 'Guyana', countryCode: 'GY' },
    { index: 102, label: 'Haiti', countryCode: 'HT' },
    { index: 103, label: 'Honduras', countryCode: 'HN' },
    { index: 104, label: 'HongKong_China', countryCode: 'HK' },
    { index: 105, label: 'Iceland', countryCode: 'IS' },
    { index: 106, label: 'India', countryCode: 'IN' },
    { index: 107, label: 'Indonesia', countryCode: 'ID' },
    { index: 108, label: 'Iraq', countryCode: 'IQ' },
    { index: 109, label: 'Ireland', countryCode: 'IE' },
    { index: 110, label: 'Israel', countryCode: 'IL' },
    { index: 111, label: 'Jamaica', countryCode: 'JM' },
    { index: 112, label: 'Japan', countryCode: 'JP' },
    { index: 113, label: 'Jordan', countryCode: 'JO' },
    { index: 114, label: 'Kazakstan', countryCode: 'KZ' },
    { index: 115, label: 'Kenya', countryCode: 'KE' },
    { index: 116, label: 'Kiribati', countryCode: 'KI' },
    { index: 117, label: 'Korea', countryCode: 'KR' },
    { index: 118, label: 'Kosovo', countryCode: 'XK' },
    { index: 119, label: 'Kuwait', countryCode: 'KW' },
    { index: 120, label: 'Kyrgyzstan', countryCode: 'KG' },
    { index: 121, label: 'Laos', countryCode: 'LA' },
    { index: 122, label: 'Latvia', countryCode: 'LV' },
    { index: 123, label: 'Lebanon', countryCode: 'LB' },
    { index: 124, label: 'Lesotho', countryCode: 'LS' },
    { index: 125, label: 'Liberia', countryCode: 'LR' },
    { index: 126, label: 'Libya', countryCode: 'LY' },
    { index: 127, label: 'Liechtenstein', countryCode: 'LI' },
    { index: 128, label: 'Lithuania', countryCode: 'LT' },
    { index: 129, label: 'Luxembourg', countryCode: 'LU' },
    { index: 130, label: 'Macao_China', countryCode: 'MO' },
    { index: 131, label: 'NorthMacedonia', countryCode: 'MK' },
    { index: 132, label: 'Madagascar', countryCode: 'MG' },
    // { index: 133, label: 'MainlandChina', countryCode: 'CN' },
    { index: 134, label: 'Malaysia', countryCode: 'MY' },
    { index: 135, label: 'Malawi', countryCode: 'MW' },
    { index: 136, label: 'Maldives', countryCode: 'MV' },
    { index: 137, label: 'Mali', countryCode: 'ML' },
    { index: 138, label: 'Malta', countryCode: 'MT' },
    { index: 139, label: 'MarshallIslands', countryCode: 'MH' },
    { index: 140, label: 'Martinique', countryCode: 'MQ' },
    { index: 141, label: 'Mauritania', countryCode: 'MR' },
    { index: 142, label: 'Mauritius', countryCode: 'MU' },
    { index: 143, label: 'Mexico', countryCode: 'MX' },
    { index: 144, label: 'Micronesia', countryCode: 'FM' },
    { index: 145, label: 'Moldova', countryCode: 'MD' },
    { index: 146, label: 'Monaco', countryCode: 'MC' },
    { index: 147, label: 'Mongolia', countryCode: 'MN' },
    { index: 148, label: 'Montenegro', countryCode: 'ME' },
    { index: 149, label: 'Montserrat', countryCode: 'MS' },
    { index: 150, label: 'Morocco', countryCode: 'MA' },
    { index: 151, label: 'Mozambique', countryCode: 'MZ' },
    { index: 152, label: 'Namibia', countryCode: 'NA' },
    { index: 153, label: 'Nauru', countryCode: 'NR' },
    { index: 154, label: 'Nepal', countryCode: 'NP' },
    { index: 155, label: 'NewCaledonia', countryCode: 'NC' },
    { index: 156, label: 'NewZealand', countryCode: 'NZ' },
    { index: 157, label: 'Nicaragua', countryCode: 'NI' },
    { index: 158, label: 'Niger', countryCode: 'NE' },
    { index: 159, label: 'Nigeria', countryCode: 'NG' },
    { index: 161, label: 'Oman', countryCode: 'OM' },
    { index: 162, label: 'Palau', countryCode: 'PW' },
    { index: 163, label: 'Pakistan', countryCode: 'PK' },
    { index: 164, label: 'Palestine', countryCode: 'PS' },
    { index: 165, label: 'Panama', countryCode: 'PA' },
    { index: 166, label: 'PapuaNewGuinea', countryCode: 'PG' },
    { index: 167, label: 'Paraguay', countryCode: 'PY' },
    { index: 168, label: 'Peru', countryCode: 'PE' },
    { index: 169, label: 'Philippines', countryCode: 'PH' },
    { index: 170, label: 'PuertoRico', countryCode: 'PR' },
    { index: 171, label: 'Qatar', countryCode: 'QA' },
    { index: 172, label: 'Russia', countryCode: 'RU' },
    { index: 173, label: 'Rwanda', countryCode: 'RW' },
    { index: 174, label: 'SaintBarthelemy', countryCode: 'BL' },
    { index: 175, label: 'SaintKittsAndNevis', countryCode: 'KN' },
    { index: 176, label: 'SaintLucia', countryCode: 'LC' },
    { index: 177, label: 'SaintMartin_FrenchPart', countryCode: 'MF' },
    { index: 178, label: 'SaintPierreAndMiquelon', countryCode: 'PM' },
    { index: 179, label: 'SaintVincentAndTheGrenadines', countryCode: 'VC' },
    { index: 180, label: 'Samoa', countryCode: 'WS' },
    { index: 181, label: 'SanMarino', countryCode: 'SM' },
    { index: 182, label: 'SaoTomeAndPrincipe', countryCode: 'ST' },
    { index: 183, label: 'SaudiArabia', countryCode: 'SA' },
    { index: 184, label: 'Senegal', countryCode: 'SN' },
    { index: 185, label: 'Seychelles', countryCode: 'SC' },
    { index: 186, label: 'SierraLeone', countryCode: 'SL' },
    { index: 187, label: 'Singapore', countryCode: 'SG' },
    { index: 189, label: 'Somalia', countryCode: 'SO' },
    { index: 190, label: 'SouthAfrica', countryCode: 'ZA' },
    { index: 191, label: 'SriLanka', countryCode: 'LK' },
    { index: 192, label: 'Suriname', countryCode: 'SR' },
    { index: 193, label: 'Swaziland', countryCode: 'SZ' },
    { index: 194, label: 'Tajikistan', countryCode: 'TJ' },
    { index: 195, label: 'Tanzania', countryCode: 'TZ' },
    { index: 196, label: 'Taiwan_China', countryCode: 'TW' },
    { index: 197, label: 'Thailand', countryCode: 'TH' },
    { index: 198, label: 'Timor_Leste', countryCode: 'TL' },
    { index: 199, label: 'Togo', countryCode: 'TG' },
    { index: 200, label: 'Tonga', countryCode: 'TO' },
    { index: 201, label: 'TrinidadAndTobago', countryCode: 'TT' },
    { index: 202, label: 'Tunisia', countryCode: 'TN' },
    { index: 203, label: 'Turkey', countryCode: 'TR' },
    { index: 204, label: 'Turkmenistan', countryCode: 'TM' },
    { index: 205, label: 'TurksAndCaicosIslands', countryCode: 'TC' },
    { index: 206, label: 'Uganda', countryCode: 'UG' },
    { index: 207, label: 'Ukraine', countryCode: 'UA' },
    { index: 208, label: 'UnitedArabEmirates', countryCode: 'AE' },
    { index: 210, label: 'Uruguay', countryCode: 'UY' },
    { index: 211, label: 'Uzbekistan', countryCode: 'UZ' },
    { index: 212, label: 'Vanuatu', countryCode: 'VU' },
    { index: 213, label: 'Vatican', countryCode: 'VA' },
    { index: 214, label: 'Venezuela', countryCode: 'VE' },
    { index: 215, label: 'Vietnam', countryCode: 'VN' },
    { index: 216, label: 'VirginIslands_British', countryCode: 'VG' },
    { index: 217, label: 'VirginIslands_US', countryCode: 'VI' },
    { index: 218, label: 'Yemen', countryCode: 'YE' },
    { index: 219, label: 'Zambia', countryCode: 'ZM' },
    { index: 220, label: 'Zimbabwe', countryCode: 'ZW' },
    { index: 221, label: 'NorthernMarianaIslands', countryCode: 'MP' },
    { index: 222, label: 'Guam', countryCode: 'GU' },
    { index: 223, label: 'AmericanSamoa', countryCode: 'AS' },
    { index: 224, label: 'BritishIndianOceanTerritory', countryCode: 'IO' },
    { index: 225, label: 'Sudan', countryCode: 'SD' },
    { index: 226, label: 'Mayotte', countryCode: 'YT' },
    { index: 227, label: 'SaintHelena', countryCode: 'SH' },
    { index: 228, label: 'FaroeIslands', countryCode: 'FO' },
    { index: 289, label: 'Gibraltar', countryCode: 'GI' },
    { index: 290, label: 'NorfolkIsland', countryCode: 'NF' },
    { index: 291, label: 'SolomonIslands', countryCode: 'SB' },
    { index: 292, label: 'Niue', countryCode: 'NU' },
    { index: 293, label: 'WallisandFutuna', countryCode: 'WF' },
    { index: 294, label: 'Tuvalu', countryCode: 'TV' },
    { index: 295, label: 'Tokelau', countryCode: 'TK' },
    { index: 308, label: 'SouthSudan', countryCode: 'SS' },
    { index: 309, label: 'Reunion', countryCode: 'RE' }
  ];
  if (process.env.appmode === 'LTS') {
    //lts没有俄罗斯大区
    countryArr = countryArr.filter((item) => {
      return item.index !== 172 && item.index !== 133;
    });
  }
  return countryArr.sort((a, b) => a.label.localeCompare(b.label));
};

/**
 * @type {{[index: string]: { index: number, label: string, countryCode: string }}}
 */
export const COUNTRY_OR_REGION_MAP = COUNTRY_OR_REGION_LIST().reduce((obj, item) => {
  obj[item.index] = item;
  return obj;
}, {});
